import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../redux/projects/actions.projects';
import { Environment } from '../../../../const/environment';
import capitalize from '../../../../services/mini/capitalize';
import projectHelper from '../../../../services/ProjectHelper';
import createNewScriptHelper from '../../../../services/actionHelpers/createNewScriptHelper';
import getProjectId from '../../../../services/mini/getProjectId';
import scriptDraftService from '../../../../services/ScriptDraftService';
import downloadScriptsHelper from '../../../../services/actionHelpers/downloadScriptsHelper';
import listenChangesInScripts from '../../../../hoc/listenChangesInScripts';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { ScriptsDropZone } from '../ScriptsDropZone/ScriptsDropZone';

class ScriptsPanelMini extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            exportInProgress: false,
            hasUnsavedChanges: false,
            unsavedScripts: 0
        };
        this.downloadScriptsPreventMissClicks = _.debounce(this.downloadScripts, 500);
    }

    componentDidMount() {
        this.checkUpdatesInProject();
    }
    componentDidUpdate() {
        this.checkUpdatesInProject();
    }

    checkUpdatesInProject = async () => {
        const { project, isScriptSaving } = this.props;
        const hasChanges = await projectHelper.hasUnsavedChanges(this.props.project);

        if (this.state.hasUnsavedChanges !== hasChanges) {
            this.setState({ hasUnsavedChanges: hasChanges });
        }

        let unsavedScripts = 0;
        if (project && project.scripts && !isScriptSaving) {
            for (let i = 0; i < project.scripts.length; i++) {
                const script = project.scripts[i];
                const hasDraft = await scriptDraftService.hasDraft(script.scriptId);
                if (hasDraft) {
                    unsavedScripts++;
                }
            }
        }
        if (this.state.unsavedScripts !== unsavedScripts) {
            this.setState({ unsavedScripts });
        }
    }


    addScript = () => {
        const { project, createScript } = this.props;
        createNewScriptHelper(project, createScript);
    }

    downloadScripts = () => {
        const {
            project,
            environment
        } = this.props;

        this.setState({ exportInProgress: true }, async () => {
            try {
                await downloadScriptsHelper(project, environment);
                this.resetScriptsDownloading();
            } catch (e) {
                this.resetScriptsDownloading();
            }
        });
    }

    resetScriptsDownloading = () => {
        setTimeout(() => {
            this.setState({ exportInProgress: false });
        }, 8000);
    }

    updateScripts = () => {
        const { project, updateScripts, environment } = this.props;
        updateScripts({ project, environment });
    }

    render() {
        const {
            project,
            environment,
            importFiles,
            importConflictScripts,
        } = this.props;
        const {
            hasUnsavedChanges,
            unsavedScripts
        } = this.state;

        const isLastTag = projectHelper.isLastTag(project, this.props[`selected${capitalize(environment)}TagId`]);
        const disabledAddScriptBtn = !isLastTag || environment !== Environment.Staging;
        const disabledSaveScriptsBtn = !hasUnsavedChanges || environment !== Environment.Staging;
        const disableDownloadBtn = project.scripts.length === 0;

        return (
            <div className="scripts-panel-mini">
                <div className={`scripts-panel-mini_btn ${disabledAddScriptBtn && 'disabled'} `}
                    onClick={!disabledAddScriptBtn ? this.addScript : undefined}
                    title="Add Script">
                    <i className="icon icon-alan-plus-stroked" />
                </div>
                <div className={`scripts-panel-mini_btn ${disableDownloadBtn && 'disabled'}`}
                    onClick={!disableDownloadBtn ? this.downloadScriptsPreventMissClicks : undefined}
                    title="Download scripts as .zip file">
                    <i className="icon icon-alan-load-down" />
                </div>
                {isLastTag &&
                    <div className={`scripts-panel-mini_btn`}
                        title="Import scripts">
                        <ScriptsDropZone
                            project={project}
                            environment={environment}
                            importConflictScripts={importConflictScripts}
                            importFiles={importFiles}>
                            <i className="icon icon-alan-load-up" />
                        </ScriptsDropZone>
                    </div>
                }
                <div className={`scripts-panel-mini_btn unsaved-scripts ${unsavedScripts > 1 && 'more-than-one-script'} ${disabledSaveScriptsBtn && 'disabled'} ${unsavedScripts === 1 && 'one-script'}`}
                    title="Save Changes"
                    onClick={!disabledSaveScriptsBtn ? this.updateScripts : undefined}>
                    <i className="icon icon-alan-save-changes" />
                    {unsavedScripts === 0 && <i className="icon icon-alan-ok-fat" />}
                    {unsavedScripts > 1 && <div className="scripts-panel-mini_unsaved-scripts">{unsavedScripts}</div>}
                </div>
            </div>
        );
    }
}

function mapStateToProps({ projectsInfo }, ownProps) {
    const projectName = ownProps.projectName;
    const projectId = getProjectId(projectName, projectsInfo.projects);
    const project = projectsInfo.currentProject;

    return {
        projectName: projectName,
        projectId: projectId,
        project: projectsInfo.currentProject,
        importConflictScripts: projectsInfo.currentProject.importConflictScripts,
        selectedStageTagId: project.stageTagId,
        selectedTestingTagId: project.testingTagId,
        selectedProdTagId: project.prodTagId,
        isScriptSaving: project.isScriptSaving,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createScript: (param) => dispatch(actions.createScript(param)),
        updateScripts: (param) => dispatch(actions.updateScripts(param)),
        importFiles: (param) => asyncDispatch(actions.importFiles, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(listenChangesInScripts(ScriptsPanelMini));
